export function beforeDestroy() {
  document.removeEventListener('focus', this.onFocus)
  document.removeEventListener('keydown', this.onKeyDown)

  console.debug('in beforeDestroy...')

  this.unsubWindowStore()
}
